module.exports = __webpack_public_path__ + "img/bns-white.a5854e53.png";